import styled from '@themes/theme'

export const NoAccessWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-wrap: wrap;
  flex-flow: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  text-align: center;
  .no-access-img {
    width: 145px;
    height: auto;
    margin-right: -10px;
  }
  .point-color--yellow {
    margin: 36px 0 18px;
    font-size: ${props => props.theme.font.large};
  }
  .explain-txt {
    line-height: 2.4rem;
    font-size: ${props => props.theme.font.large};
    font-weight: ${props => props.theme.fontW.medium};
  }
`
